import React from 'react';
import FeedbackManagementPanel from '@/components/FeedbackManagementPanel';

const FeedbackManagement = () => {
  return (
    <div className="container mx-auto py-8">
      <FeedbackManagementPanel />
    </div>
  );
};

export default FeedbackManagement;